import './GameComponent.css';
import PlayerResources from "./player/resources/PlayerResources";
import CpuResources from "./cpu/resources/CpuResources";
import PlayerHp from "./player/hp/PlayerHp";
import CpuHp from "./cpu/hp/CpuHp";
import PlayerHand from "./player/hand/PlayerHand";
import PlayerTable from "./player/table/PlayerTable";
import CpuTable from "./cpu/table/CpuTable";
import EndTurnButton from "./endturn/EndTurnButton";
import PlayedCard from "./playedcard/PlayedCard";
import EndGame from "./end_game/EndGame";
import Message from "./message/Message";
import {useTypedSelector} from '../../hooks/useTypedSelector';
import TutorialComponent from '../tutorial/TutorialComponent';
import React, {useEffect} from 'react';
import CardVeryBig from "../card/CardVeryBig";
import {useActions} from "../../hooks/useActions";
import Counters from "./counters/Counters";
import BattleMenu from "./battle_menu/BattleMenu";
import PlayerPlaySpellDropZone from "./player/hand/PlayerPlaySpellDropZone";
import PlayerTimer from "./timers/PlayerTimer";
import CpuTimer from "./timers/CpuTimer";
import Mulligan from "./mulligan/Mulligan";
import Header from "./header/Header";
import Loading from "./Loading/Loading";
import CardDndPreview from "./CardDndPreview";
import {isMobile} from 'react-device-detect';


function GameComponent() {

    const {game, isPvP, gamePvPData, phase, playerHand, playedCard} = useTypedSelector(state => state.game);
    const {tutorial} = useTypedSelector(state => state.auth);
    const {processPvPGame, setGamePvPData, setTutorial, setPhase, setPlayerHand, setPlayedCard} = useActions();


    if (isPvP === true && gamePvPData !== null) {
        let gamePvPDataLocal = gamePvPData;
        setGamePvPData(null);

        setTimeout(() => processPvPGame(gamePvPDataLocal), 100);
    }
    useEffect(() => {
        // Tutorial
        if (tutorial.step === 'BossWindow30-skip-comics') {
            tutorial.step = 'showRes35';
            setTutorial(tutorial);
        }
        //
    });

    useEffect(() => { // cancel played card, unit or spell
        if (tutorial.isActive) {
            return;
        }

        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement | null;

            if (!target) {
                return;
            }

            const found =
                target.closest('.tableTarget.tableTargetActive') ||
                target.closest('.clickPlaySpellTarget') ||
                target.closest('.hp_cpu') ||
                target.closest('.hp_player') ||
                target.closest('.hpAmount');

            if (!found) {
                if (phase === 'select_unit_target' || phase === 'select_spell_target') {
                    setPhase('play_card');

                    if (playedCard.handKey) {
                        playerHand[playedCard.handKey] = playedCard.card;
                        setPlayerHand(playerHand);
                    }

                    setPlayedCard({ card: null, handKey: null, target: null });
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, [phase]);

    return (
        <div className='gameComponentContainer'>
            <Loading />
            <CardVeryBig/>
            <Message/>

            <Header/>

            <BattleMenu/>

            {(isPvP || game?.cpu_id === 21) ?
                <CpuTimer/>
                : <div></div>
            }
            <Counters key={'cpu_c_1'} side={'cpu'}/>
            <CpuHp/>

            <CpuResources/>


            {(isPvP || game?.cpu_id === 21) ?
                <PlayerTimer/>
                : <div></div>
            }
            <Counters key={'player_c_1'} side={'player'}/>
            <PlayerHp/>
            <PlayerResources/>

            <div className='gameBattlefieldContainer'>
                <div className='gameBattlefield'>
                    <CpuTable/>
                    <PlayerTable/>
                </div>
            </div>

            <PlayedCard/>

            <EndTurnButton/>
            <Mulligan />

            { isMobile ? (
            <CardDndPreview />
            ):null
            }

            <PlayerPlaySpellDropZone/>
            <PlayerHand/>

            <EndGame/>

            <TutorialComponent/>

        </div>
    );
}

export default GameComponent;